import React from 'react'

const RequestAPI = () => {
  return (
    <div>Request API Access here</div>
  )
}

export default RequestAPI